export default {
  name: 'purchase',
  translationKey: 'purchase-module',
  routePrefix: 'purchase',
  routeNamePrefix: 'purchase',
  directRoutesAvailable: true,
}
